import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './components/home/Home.jsx';
import Members from './components/members/Members.jsx';
import Footer from './components/footer/Footer.jsx';
import MyNavbar from './components/my-navbar/MyNavbar.jsx';
import BlogDetails from './components/blog_details/BlogDetails.jsx';
import Banner from './components/banner/Banner.jsx';
import About from './components/about/About.jsx';
import President from './components/president/President.jsx';
import Gallery from './components/gallery/Gallery.jsx';
import Blog from './components/blog/Blog.jsx';
import Contact from './components/contact/Contact.jsx';
import Login from './components/login/Login.jsx';
import Viewmoreimage from './components/gallery/viewmoreimage.jsx';
import Viewmorevideos from './components/gallery/viewmorevideos.jsx';
import ViewMoreMemory from './components/memory/viewmorememory.jsx';
import ViewMoreBlog from './components/blog/viewmoreblog.jsx';
import ViewMoreEvents from './components/events/viewmoreevent.jsx';




function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <MyNavbar/>
        <Routes>
          <Route exact path="/" element={<Home />} />
          {/* <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Career />} />
          <Route path="/products" element={<Products />}></Route>
          <Route path="/otherbrands" element={<OtherBrands />}></Route>
          <Route path="/item" element={<Item />} />
          <Route path="/recepies" element={<Recepies />} />
          <Route path="/recepies/select" element={<Select />} />
          <Route path="/viewcategory" element={<Viewcategory />} />
          <Route path="/gallery" element={<Gallery />} /> */}
          <Route path ="/members" element={<Members/>}/>
          <Route path="/blog-details/" element={<BlogDetails />} />
          <Route path="/viewmoreimages" element={<Viewmoreimage/>}/>
          <Route path="/viewmorevideos" element={<Viewmorevideos/>}/>
          <Route path="/ViewMoreMemory" element={<ViewMoreMemory/>}/>
          <Route path="/ViewMoreblog" element={<ViewMoreBlog/>}/>
          <Route path="/viewmoreevent" element={<ViewMoreEvents/>}/>
          
          {/* <Route path ="/banner" element={<Banner/>}/>
          <Route path ="/about" element={<About/>}/>
          <Route path ="/president" element={<President/>}/>
          <Route path ="/gallery" element={<Gallery/>}/>
          <Route path ="/blog" element={<Blog/>}/>
          <Route path ="/contact" element={<Contact/>}/>
          <Route path ="/login" element={<Login/>}/> */}

        </Routes>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
